import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

// TODO: Consider linking each service to a dedicated page or section
// TODO: Add service images when available from client

const ServicesOffered = () => {
  const services = [
    {
      id: 1,
      title: 'New Home Construction',
      description:
        'Custom home building for your dream residential property, tailored to your specific needs and preferences.',
      icon: 'bi-house-door',
    },
    {
      id: 2,
      title: 'Home Renovations',
      description:
        'Transform your existing home with our expert renovation services, from minor updates to major overhauls.',
      icon: 'bi-hammer',
    },
    {
      id: 3,
      title: 'Home Additions',
      description:
        'Expand your living space with custom additions that seamlessly integrate with your existing home.',
      icon: 'bi-building-add',
    },
    {
      id: 4,
      title: 'Kitchen & Bathroom Remodeling',
      description:
        'Specialized remodeling services for the most important rooms in your home, with premium fixtures and finishes.',
      icon: 'bi-droplet',
    },
    {
      id: 5,
      title: 'Interior Design',
      description:
        'Professional interior design services to enhance the functionality and aesthetics of your residential space.',
      icon: 'bi-palette',
    },
    {
      id: 6,
      title: 'Residential Project Management',
      description:
        'Full-service residential project management from initial planning to final inspection and handover.',
      icon: 'bi-clipboard-check',
    },
  ];

  console.log('[ServicesOffered] Rendering services section with', services.length, 'services');

  return (
    <section className="section">
      <h2 className="section-title">Our Services</h2>
      <Row>
        {services.map((service) => (
          <Col md={6} lg={4} className="mb-4" key={service.id}>
            <Card className="service-card h-100">
              <Card.Body className="d-flex flex-column">
                <div className="service-icon">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <Card.Title>{service.title}</Card.Title>
                <Card.Text>{service.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default ServicesOffered;
